export default {
  ManageAppSettings__BUTTON_GROUP_ARIA_NEXT: "Next",
  ManageAppSettings__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
